module.exports = __webpack_public_path__ + "static/netad-aim3-b0adaf09239b4ab075b7cd56ca94ec61.png";